<template>
    <div v-if="!isEdited">
      {{localValue}}
      <b-tooltip label="Edit" type="is-dark">
        <a href="" @click.prevent="isEdited = true">
          <b-icon icon="pencil" size="is-small"></b-icon>
        </a>
      </b-tooltip>
      <slot/>
    </div>
    <div v-else>
        <b-field>
          <b-input
              type="text"
              v-model.trim="localValue"
              @keyup.native.enter="updateValue"
              @keyup.native.esc="cancelEdit"
          />
        </b-field>
        <div>
          <b-tooltip label="Save" type="is-dark" position="is-bottom">
            <a @click.prevent="updateValue" href="" title="Save">
              <b-icon icon="content-save"/>
            </a>
          </b-tooltip>
          <b-tooltip label="Cancel" type="is-dark" position="is-bottom">
            <a @click.prevent="cancelEdit" href="" title="Cancel">
              <b-icon icon="cancel"/>
            </a>
          </b-tooltip>
        </div>
    </div>
</template>

<script>
export default {
  name: 'KycDetailsTableCell',
  props: ['value'],
  data () {
    return {
      localValue: this.value,
      isEdited: false
    }
  },
  watch: {
    value () {
      this.localValue = this.value
    }
  },
  methods: {
    updateValue () {
      this.$emit('value-changed', this.localValue)
      this.isEdited = false
    },
    cancelEdit () {
      this.localValue = this.value
      this.isEdited = false
    }
  }
}
</script>

<style scoped>

</style>
